// extracted by mini-css-extract-plugin
module.exports = {"textBannerContainer":"TextBanner_textBannerContainer__10PlN","textBannerHeader":"TextBanner_textBannerHeader__3fH5t","textBannerText":"TextBanner_textBannerText__An1yC"};